import axios from '@/plugins/axios';
import qs from 'qs';
import utils from '@/stores/utils';
import catalogs from './submodules/catalogs';
import catalogagentassignments from './submodules/catalogagentassignments';

const state = {
    agent: null
};

const mutations = {
    updateAgent(state, agent) {
        state.agent = agent;
    },
};

const actions = {

    async init({ commit, dispatch, state }, params) {
        commit('updateAgent', params.agent);
        dispatch('catalogs/init', { filters: { owned: true } });
        dispatch('catalogs/fetchCatalogs');
        const filters = { ordering: 'catalog_name' };
        if (params.agent.commercial_agent_id) {
            filters.commercial_agent = params.agent.commercial_agent_id;
        } else if (params.agent.id) {
            filters.agent = params.agent.id;
        }
        dispatch('catalogagentassignments/init', { filters });
        dispatch('catalogagentassignments/fetchCatalogAgentAssignments');
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    modules: {
        catalogagentassignments: catalogagentassignments(),
        catalogs: catalogs(),
    }
};
